import dayjs from "dayjs";

const dateIdFormat = "YYYY-MM-DD";

export default {
  // TODO - DEAL WITH TIME BEFORE MESSAGE HAS BEEN SENT
  // -- WAT?
  getWeekId() {
    return dayjs().startOf("week").format(dateIdFormat);
  },
  getNextWeekId() {
    return dayjs().add(1, "week").startOf("week").format(dateIdFormat);
  },
};
